import wixData from 'wix-data';
import {getTeamArray, recordStartTime, recordAverage, questionsSuccess} from 'backend/ramzorBack'


$w.onReady(function () {

questionsSuccess()

dlLinesHide()
$w("#text49").hide()
$w("#text65").hide()

$w("#text67").hide()
$w("#text68").hide()

$w("#button4").onClick((event)=> {showTeamResults($w("#dropdown1").value) })
$w("#button8").onClick((event)=> {showTeamResults($w("#input2").value) })

$w("#text49").hide()
for (let i=1; i<19; i++){
	$w("#t"+i).hide()
	$w("#b"+i).hide()
	$w("#p"+(i)).hide()
	}

var teamArray=[]
var groupID=0
var groupAverage=""
var totalTeamScore=0
var fineStatus=""
var playersList=[]

$w('#switch2').onChange ((event => {getIDMethod()}))
	function getIDMethod (){
let idMethod={
	"_id":"idMethod",
	"method": ""
}
if ($w('#switch2').checked === true){
	idMethod.method="phone"
} else {idMethod.method="dropdown"}
wixData.save ("ramzorAnswers",idMethod )}

$w('#dropdown2').onChange ((event) => {setFine()})
	function setFine (){
	fineStatus={
	"_id":"fineStatus",
	"fineStatus": ""
}
if ($w('#dropdown2').value ==="2"){
	fineStatus.fineStatus="fine"
} else {fineStatus.fineStatus="nofine"}
wixData.save ("ramzorAnswers",fineStatus)}


$w("#button7").onClick((event) => {
	setTimeout (function () {$w("#button7").label = "Saved"},0);
	setTimeout (function () {$w("#button7").hide("fade")},0);
	setTimeout (function () {$w("#button7").label = "Record Avarage"},2000);
	setTimeout (function () {$w("#button7").show()},2000);
		recordAverage($w("#input1").value)})
$w("#button6").onClick((event) => {
	setTimeout (function () {$w("#button6").label = "Saved"},0);
	setTimeout (function () {$w("#button6").hide("fade")},0);
	setTimeout (function () {$w("#button6").label = "Backup Answers"},2000);
	setTimeout (function () {$w("#button6").show()},2000);
		backupAnswers()})
$w("#button1").onClick((event) => {resetAnswers()})
$w("#button2").onClick((event) => {
		$w("#button2").label="Started..."
	$w("#button2").hide("fade")
	recordStartTime()
	})

wixData.query("ramzorAnswers")
.limit(600)
.find()
.then(list =>{
	//console.log(list.items)
	list.items.forEach( element =>{
		if (Object.keys(element).length >5){
			playersList.push({"label": element["_id"], "value": element["_id"]})
		}
	})

$w("#dropdown1").options=playersList
})
	


function showTeamResults (teamNumber){
dlLinesHide()
teamArray=[]	
$w("#text49").hide()
$w("#text49").hide()
$w("#text65").hide()
$w("#text67").hide()
$w("#text68").hide()
for (let i=1; i<19; i++){
	$w("#t"+i).hide()
	$w("#p"+i).hide()
	$w("#b"+i).hide()}
getTeamArray(teamNumber)
.then ((array)=> {if (array.length>1)  {teamArray=array} })

.then(() => {
	totalTeamScore=0
	groupID=teamArray[0].time0 +""
	
	if ( teamArray[0].questionValue>0){
	for (let i=0;i<18;i++){
				$w("#t"+(i+1)).text= teamArray[i].questionValue+""
				$w("#p"+(i+1)).text= teamArray[i].questionNumber+""
				$w("#b"+(i+1)).style.borderWidth="8px"
				$w("#b"+(i+1)).style.backgroundColor=teamArray[i].color+""
				if (teamArray[i].isCorrect===false && teamArray[i].answer !== undefined && teamArray[i].onTime === true){$w("#b"+(i+1)).style.borderColor="black"} 
					else if (teamArray[i].onTime === false) {$w("#b"+(i+1)).style.borderColor="gray"}
					else {$w("#b"+(i+1)).style.borderColor=teamArray[i].color}
				totalTeamScore=totalTeamScore+teamArray[i].score
				
				$w("#text49").text=totalTeamScore+""
				$w("#text68").show("fade")
				$w("#text67").show("fade")
				$w("#text49").show("fade")
				$w("#text65").show("fade")
				$w("#t"+(i+1)).show("fade")
				$w("#b"+(i+1)).show("fade")
				$w("#p"+(i+1)).show("fade")
				
				if(teamArray[i].time<240000 && teamArray[i+1].time>=240000){ $w('#d'+(i+1)).show()
																			$w('#c'+(i+1)).show()
																			$w('#c'+(i+1)).style.backgroundColor="red"
																			$w('#a'+(i+1)).text="4"}
				if(teamArray[i].time<480000 && teamArray[i+1].time >=480000){ $w('#d'+(i+1)).show()
																				$w('#c'+(i+1)).show()
																			$w('#c'+(i+1)).style.backgroundColor="orange"
																			$w('#a'+(i+1)).text="8"}
				if(teamArray[i].time<600000 && teamArray[i+1].time >=600000){ $w('#d'+(i+1)).show()
																				$w('#c'+(i+1)).show()
																			$w('#c'+(i+1)).style.backgroundColor="green"
																			$w('#a'+(i+1)).text="10"}
	}
				} 
				wixData.get ("ramzorGroupsAverage",groupID)
				.then(item => {groupAverage=item.average+""
				$w("#text68").text=groupAverage
				})
			console.log(groupID)	

			})
		
	
}


function dlLinesHide (){
	for(let i=0; i<19 ;i++){
		$w('#d'+i).hide()
		$w('#c'+i).hide()
	}
}
  
 function resetAnswers(){
	$w("#button1").hide("fade")
	wixData.query ("ramzorAnswers" )
	.find()
 	.then( (item) => {
		 item.items.forEach( element => {
			if (element.time0!==undefined){
					let item4deletionID=element["_id"]
				 	wixData.remove("ramzorAnswers", item4deletionID )
		 }
		 })
	 })
		
		  
		  	}


function backupAnswers(){
	let eventID= new Date().getTime()
	
	wixData.query ("ramzorAnswers" )
	.find()
 	.then( (item) => {
		 item.items.forEach( element => {
			if (element.time0!==undefined){
				 	let phoneNumber=element["_id"]
					element["_id"]= eventID+phoneNumber+""
					wixData.insert("ramzorBackup", element )
		 }
		 })
	 })
}	 
		 
	

	  		  	
  })
		


	